import { Card, Stack, Typography, Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useTheme } from '@mui/material/styles';

interface SearchPromptCardProps {
  title: string;
  description: string;
  searchPrompt: string;
}

export default function SearchPromptCard({ title, description, searchPrompt }: SearchPromptCardProps) {
  const theme = useTheme();

  return (
    <Card
      sx={{
        width: '100%',
        maxWidth: '600px',
        alignSelf: 'center',
        marginTop: '4em !important',
        boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        borderRadius: '12px',
        border: `1px solid ${theme.palette.grey[100]}`,
        background: 'linear-gradient(135deg, #fafbfc 0%, #ffffff 100%)'
      }}>
      <Stack spacing={3} alignItems="center" justifyContent="center" sx={{ padding: '3em 2em' }}>
        <Box
          sx={{
            background: `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
            borderRadius: '50%',
            padding: '1.2em',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: `0 4px 12px ${theme.palette.primary.main}20`
          }}>
          <SearchIcon
            sx={{
              fontSize: '2.5rem',
              color: 'white'
            }}
          />
        </Box>

        <Stack spacing={2} alignItems="center" textAlign="center">
          <Typography variant="h5" fontWeight="600" color={theme.palette.text.primary}>
            {title}
          </Typography>
          <Typography variant="body1" color={theme.palette.text.secondary} sx={{ lineHeight: 1.6, maxWidth: '400px' }}>
            {description}
          </Typography>
          <Typography
            variant="body2"
            color={theme.palette.primary.main}
            sx={{
              fontWeight: '500',
              marginTop: '1em !important',
              backgroundColor: theme.palette.primary.main + '10',
              padding: '0.5em 1em',
              borderRadius: '20px'
            }}>
            {searchPrompt}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
}
